import type { IAddRemoteNodeByGlobalId } from "~/solidJs/shared/helpers/nodeHelpers";

export const deserializeReroutingNodeAdding = async () => {
	const urlParams = new URLSearchParams(window.location.search);
	const nodeToAdd = urlParams.get("nodeToAdd");
	if (nodeToAdd) {
		const state = localStorage.getItem("nodeReroutingState");
		let nodeSchema:
			| {
					inputs: IAddRemoteNodeByGlobalId<string>["inputs"];
					params: IAddRemoteNodeByGlobalId<string>["params"];
			  }
			| undefined;
		if (state) {
			nodeSchema = JSON.parse(state);
		}

		const { addRemoteNodeByGlobalId } = await import("~/solidJs/shared/helpers/nodeHelpers");
		await addRemoteNodeByGlobalId({
			globalId: nodeToAdd,
			...(nodeSchema ? nodeSchema : {})
		});
	}
	destroyLocalStorageNodeState();
};
export const rerouteAndSerializeNodeToAdd = (props: {
	route: string;
	globalIdToAdd: string;
	inputs: IAddRemoteNodeByGlobalId<string>["inputs"];
	params: IAddRemoteNodeByGlobalId<string>["params"];
}) => {
	const { route, globalIdToAdd, inputs, params } = props;
	const url = new URL(route);
	url.searchParams.append("nodeToAdd", globalIdToAdd);
	localStorage.setItem("nodeReroutingState", JSON.stringify({ inputs, params }));
	return url.href;
};
export const destroyLocalStorageNodeState = () => {
	localStorage.removeItem("nodeReroutingState");
};
